import { render, staticRenderFns } from "./Muestras.vue?vue&type=template&id=0f88b222&scoped=true&lang=pug&"
import script from "./Muestras.vue?vue&type=script&lang=js&"
export * from "./Muestras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88b222",
  null
  
)

export default component.exports